import { render, staticRenderFns } from "./TxFilter.vue?vue&type=template&id=5486c44e&scoped=true&"
import script from "./TxFilter.vue?vue&type=script&lang=ts&"
export * from "./TxFilter.vue?vue&type=script&lang=ts&"
import style0 from "./TxFilter.vue?vue&type=style&index=0&id=5486c44e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486c44e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
